import BaseModel from '../BaseModel';
import { resourceType } from '../../../enums';

export default class Client extends BaseModel {
  static entity = 'clients';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      fetchById(id, key = null) {
        return this.model.handleFetching(() => this.get(`oauth/clients/${id}`), key || id);
      },
      async check(payload) {
        const { response } = await this.get('oauth/authorize', { params: payload });

        if (response.data.type === resourceType.REDIRECT) {
          window.location.replace(response.data.data.uri);
        }

        return response;
      },
      async approve(payload) {
        const { response } = await this.post('oauth/authorize', null, { params: payload }, { save: false });

        if (response.data.type === resourceType.REDIRECT) {
          window.location.replace(response.data.data.uri);
        }

        return response;
      },
      async deny(payload) {
        const { response } = await this.delete('oauth/authorize', { params: payload }, { save: false });

        if (response.data.type === resourceType.REDIRECT) {
          window.location.replace(response.data.data.uri);
        }

        return response;
      },
    },
  }
}
